import $$ from 'cmn-utils';
import modelEnhance from '@/utils/modelEnhance';
import { routerRedux } from 'dva/router';
import config from '@/config';
import { isPC } from '@/utils/common/common';
import { bindWeChat } from '@/routes/System/Wechat/service/index.js';

let notice = config.notice;

export default modelEnhance({
  namespace: 'global',

  state: {
    menu: [],
    flatMenu: [],
  },

  // gets=(url)=> {
  //   // XMLHttpRequest对象用于在后台与服务器交换数据  
  //   var xhr = new XMLHttpRequest();            
  //   xhr.open('POST', url, true);
  //   xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");  
  //   xhr.onreadystatechange = function() {
  //     // readyState == 4说明请求已完成
  //     alert(xhr.readyState + "," + xhr.status);
  //     if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) { 
  //       // 从服务器获得数据 
  //       // fn.call(this, xhr.responseText);  
  //       alert(xhr.responseText)
  //     }
  //   };
  //   xhr.send("");
  // },

  effects: {
    *getMenu({ payload = {}}, { call, put }) {
      //如果是扫码绑定终端的请求则处理后放过
      if(window.location.href.indexOf('qrresult=') > 0){
          let sn = decodeURIComponent(window.location.href).split("sn=")[1].split("#")[0];
          $$.setStore("bind_sn",sn);
          // window.history.go(-1);
          window.location.href = window.contextPath + '#/sign/wechat';
        return;
      }else{
        $$.setStore("open_clientScanCode",false);
        let user = $$.getStore("user");
        let token = window.sessionStorage.getItem("token");
        if(!token || !user || !user.role || !user.role.menuList){
          // notice.error('会话已过期,请重新登录')
          let isPc = isPC();
          if (isPc) {
            yield put(routerRedux.replace('/sign'));
            return;
          } else {
            window.location.href = window.contextPath + '#/link/login';
            return;
          }
        }
  
        let root = user.role.menuList;
        const props = yield call(generateMenuTree, root);
  
        if (root) {
          const loopMenu = (menu, pitem = {}) => {
            menu.forEach(item => {
              if (pitem.path) {
                item.parentPath = pitem.parentPath ? pitem.parentPath.concat(pitem.path) : [pitem.path];
              }
              if (item.children && item.children.length) {
                loopMenu(item.children, item);
              }
            });
          }
          loopMenu(props);
          
          yield put({
            type: 'getMenuSuccess',
            payload: props,
          });
        }
      }
    },
  },

  reducers: {
    getMenuSuccess(state, { payload }) {
      return {
        ...state,
        menu: payload,
        flatMenu: getFlatMenu(payload),
      };
    }
  },
});

export function getFlatMenu(menus) {
  let menu = [];
  menus.forEach(item => {
    if (item.children) {
      menu = menu.concat(getFlatMenu(item.children));
    }
    menu.push(item);
  });
  return menu;
}

export  function generateMenuTree(menuList){
  menuList || (menuList = []);
  
  //三级菜单不展示，素材下面的菜单不展示
  let newMenuList = [];
  for (let i = 0; i< menuList.length; i++) {
    if (menuList[i].menuLevel < 3 && menuList[i].pid !== "11000000") {
      newMenuList.push(menuList[i]);
    }
  }

  return newMenuList.map(item => {
    //菜单国际化
    let name = window.language[item.name];
    if(item.childList && item.childList.length > 0){
      return {
        id: item.id,
        name: name,
        icon: item.iconUrl,
        path: item.action,
        children: generateMenuTree(item.childList),
      }
    }else{
      return {
        id: item.id,
        name: name,
        icon: item.iconUrl,
        path: item.action,
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/models/global.js